export const COMMON_AXIS_PROPS = {
  hideTicks: true,
  hideAxisLine: true,
  tickClassName: 'fill-neutral-30 text-xs',
  tickLength: 10,
  tickLineProps: {
    className: 'stroke-global-stroke',
  },
  tickLabelProps: () => ({
    textAnchor: 'start' as const,
    verticalAnchor: 'middle' as const,
  }),
};
